import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class CleanUserGeneratedHtmlService {
  private _sanitizer = inject(DomSanitizer);

  clean(html: string) {
    if (!html) return '';
    if (typeof window === 'undefined') {
      console.warn('cleanUserGeneratedHtmlService.clean is not supported on the server');
      return '';
    }

    const div = document.createElement('div');
    div.innerHTML = this._sanitizer.sanitize(SecurityContext.HTML, html).replace(/<img .*>/, '');
    div.querySelectorAll('a').forEach(a => {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'no-follow');
    });
    return div.innerHTML;
  }
}
